module.exports = __webpack_public_path__ + "static/media/chevron-right.5d09b399.svg";